// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_menu-item__opq6Q","title":"MenuItem_title__xdDyg"};